export default {
  English: 'English',
  Français: 'French',
  Deutsch: 'German',
  Italliano: 'Italian',
  Español: 'Spanish',
  Next: 'Next',
  Back: 'Back',
  //META DATA in general file
 //TOP LINE PAY LATER in general file

//PAY LATER MODAL INFO WINDOW  in general file
  //STEP 1 TILES in general file

//STEP2  in general file
//STEP2
  TILE_TECH_LIC_UPGRADE_TITLE: '<b>Upgrade to Safe PST Backup Technical license</b>',
  TILE_TECH_LIC_UPGRADE_TITLE_DIV: 'Upgrade to Safe PST Backup Technical license',
  TILE_TECH_LIC_UPRAGE_DESCRIPTION: 'Cost-effective solution for technicians.<br/>Unlimited installations. ',
  TILE_TECH_LIC_UPGRADE_MODAL_TITLE: 'Upgrade to Safe PST Backup Technical license',
  TILE_TECH_LIC_UPGRADE_MODAL_DESCRIPTION: 'Cost-effective solution for technicians.<br/>Unlimited installations. ',

 //STEP3 -- partially in general file (title and All you can eat bundle)

  TILE_BUNDLE_MAIN_TITLE: '<b>PST & OST Management Bundle</b>',
  TILE_BUNDLE_MAIN_TITLE_DIV: 'PST & OST Management Bundle',
  TILE_BUNDLE_MAIN_DESCRIPTION1: 'Merge, split or archive PST files. Convert OST files to PST.',
  TILE_BUNDLE_MAIN_TITLE_MODAL: '<b>PST & OST Management bundle</b>',
  TILE_BUNDLE_MAIN_DESCRIPTION_MODAL: 'Buy PST & OST Management Bundle and you will receive:',
  TILE_BUNDLE_MAIN_S2_DESCRIPTION: ' - Synchronize Microsoft Outlook data between multiple PC’s.',
  TILE_BUNDLE_MAIN_S2C_DESCRIPTION: ' - Synchronize Microsoft outlook data with multiple sources: iCloud, Google, Microsoft Exchange.',
  TILE_BUNDLE_MAIN_DR_DESCRIPTION: ' - find and remove Outlook duplicate items in just one click.',
  TILE_BUNDLE_MAIN_SPB_DESCRIPTION: ' - automatic Outlook PST and Exchange folders backup tool.',
  TILE_BUNDLE_MAIN_OT_DESCRIPTION: ' - resolve Outlook problems with Outlook toolbox.',

  TILE_BUNDLE_MAIN_OST2_DESCRIPTION: ' - Convert OST to PST files and connect converted files to Microsoft Outlook',
  TILE_BUNDLE_MAIN_SPLITTER_DESCRIPTION: ' - Split your PST file automatically or manually.',
  TILE_BUNDLE_MAIN_MERGER_DESCRIPTION: ' - Merge multiple PST files into a single file.',
  TILE_BUNDLE_MAIN_VIEWER_DESCRIPTION: ' - View PST and OST files in a few clicks without Microsoft Outlook.',
  TILE_BUNDLE_MAIN_S2_NAME: 'Sync2',
  TILE_BUNDLE_MAIN_S2_URL: 'https://www.sync2.com/',
  TILE_BUNDLE_MAIN_S2C_NAME: 'Sync2 Cloud',
  TILE_BUNDLE_MAIN_S2C_URL: 'https://cloud.sync2.com/',
  TILE_BUNDLE_MAIN_DR_NAME: 'Outlook Duplicate Remover',
  TILE_BUNDLE_MAIN_DR_URL: 'https://www.duplicate-remover.com/',
  TILE_BUNDLE_MAIN_SPB_NAME: 'Safe PST Backup',
  TILE_BUNDLE_MAIN_SPB_URL: 'https://www.safepstbackup.com/',
  TILE_BUNDLE_MAIN_OT_NAME: 'Outlook Toolbox',
  TILE_BUNDLE_MAIN_OT_URL: 'https://outlooksupport.4team.biz/resolve-outlook-problems-with-outlook-toolbox',
  TILE_BUNDLE_MAIN_OST2_NAME: 'OST2',
  TILE_BUNDLE_MAIN_OST2_URL: 'https://www.ost2.com/',
  TILE_BUNDLE_MAIN_SPLITTER_NAME: 'PST Splitter',
  TILE_BUNDLE_MAIN_SPLITTER_URL: 'http://www.pst-file-splitter.com/',
  TILE_BUNDLE_MAIN_MERGER_NAME: 'PST Merger',
  TILE_BUNDLE_MAIN_MERGER_URL: 'http://www.pst-merger.com/',
  TILE_BUNDLE_MAIN_VIEWER_NAME: 'OST PST Viewer',
  TILE_BUNDLE_MAIN_VIEWER_URL: 'https://www.ostpstviewer.com/',


//STEP4  in general file

 //Tiles buttons  in general file
//Tiles links  in general file
//Tiles Price & Save  in general file

    //MODAL WHY UPGRADE in general file
  //MODAL WHY LIFETIME UPGRADE in general file
 // MODAL WHY SUBSCRIPTION UPGRADE in general file


  //MODAL WHY Tech lic
  MODAL_WHY_TECH_LIC_TITLE: 'Safe PST Backup Technical License',
  MODAL_WHY_TECH_LIC_DESCTIPTION:
    "Safe PST Backup Technical License is a cost-effective solution for technicians who support and provide services for small offices, organizations and companies. With a single license, the technician can support multiple PCs that may have one or multiple orphaned OST files that contain valuable email, contact and calendar data. There's no limitation of file size or quantity of OST files to convert.",
  MODAL_WHY_TECH_LIC_BENEFITS_TEXT:
    '<ul class="modal-description-ul"><li>Installation support: Unlimited installations on multiple computers, user accounts and on different locations.</li><li>License: concurrent use. Only one software installation can be activated and used per one Technical license at a time. To use the same license on another PC, license deactivation is required.</li><li>License Deactivations: Unlimited. Internet connection required.</li><li>Technical Support: 1 year FREE Unlimited. Chat, e-mail.</li><li>Product Updates: 1 year FREE  Product Updates.</li><li>Electronic Delivery: The delivery of the product is automated. You will receive an e-mail containing both the link to download the product and the Activation Code within a few minutes after payment confirmation. Lincense instant delivery by e-mail.</li><li>Money Back Policy: 14 Day, No questions asked, Money Back guarantee.</li></ul>',
  MODAL_WHY_TECH_LIC_NOTE: 'If you are interested in a custom solution, please fill out our <a href="https://www.Safe PST Backup.com/questionnaire.aspx"> Safe PST Backup Questionnaire</a>.<br>* To activate the Safe PST Backup Technical license, you must have the software primary license.',


 // MODAL BUNDLES ADDITIONAL TEXT   in general file
  // MODAL LIFETIME ADDITIONAL TEXT   in general file

 //PURCHASE STEPS BAR --   in general file
 //NOTES AND PAYMENT CARDS ICONS in general file

    //INFO LINKS--   in general file
  //FOOTER--   in general file
 //EMAIL VALIDATION--   in general file

  //burger menu
  MENU_DOWNLOAD: 'Download',
  MENU_DOWNLOAD_TITLE: 'Click here to download Safe PST Backup',
  MENU_FEATURES: 'Features',
  MENU_FEATURES_TITLE: 'Take a Tour (How to sync Outlook. Sync Outlook with Google.)',
  MENU_PRICING: 'Pricing',
  MENU_PRICING_TITLE: 'Pricing',
  MENU_TESTIMONIALS: 'Testimonials',
  MENU_TESTIMONIALS_TITLE: 'Click here to view Safe PST Backup reviews, customer testimonials and feedbacks',
  MENU_FAQ: 'FAQ',
  MENU_FAQ_TITLE: 'Click here to read frequently asked questions',
  MENU_SUPPORT: 'Support',
  MENU_SUPPORT_TITLE: 'Support',
  MENU_RESOURCES: 'Resources',
  MENU_RESOURCES_TITLE: 'Resources',
  MENU_RESOURCES_SCREENSHOTS_VIDEO: 'Screenshots & Videos',
  MENU_RESOURCES_SCREENSHOTS_VIDEO_TITLE: 'Screenshots & Videos',
  MENU_RESOURCES_DOCUMENTATION: 'Documentation',
  MENU_RESOURCES_DOCUMENTATION_TITLE: 'Documentation',
  MENU_RESOURCES_INSTALLATION_INSTRUCTIONS: 'Installation Instructions',
  MENU_RESOURCES_INSTALLATION_INSTRUCTIONS_TITLE: 'Installation Instructions',
  MENU_RESOURCES_VERSION_HISTORY: 'Version history',
  MENU_RESOURCES_VERSION_HISTORY_TITLE: 'Version history',
  MENU_RESOURCES_SYSTEM_REQUIREMENTS: 'System requirements',
  MENU_RESOURCES_SYSTEM_REQUIREMENTS_TITLE: 'System requirements',
  MENU_RESOURCES_FAQ: 'Frequently Asked Questions',
  MENU_RESOURCES_FAQ_TITLE: 'Frequently Asked Questions',
  MENU_RESOURCES_HELP: 'Help',
  MENU_RESOURCES_HELP_TITLE: 'Help',
  MENU_MY_ACCOUNT: 'My Account',
  MENU_MY_ACCOUNT_TITLE: 'Review your account details',
  MENU_SELECT_LANG: 'Select Your Language',
  MENU_SELECT_LANG_TITLE: 'Select Your Language',
  MENU_CLOSE: 'Close',

  //PAGE LINKS:
  URL_ABOUT_US: "https://www.4team.biz/about.aspx",
  URL_LICENSING: "https://www.4team.biz/eula.aspx",
  URL_FAQ: "https://www.safepstbackup.com/frequently-asked-questions.aspx",
  URL_SYSTEM_REQUIREMENTS: "https://www.safepstbackup.com/system-requirements.aspx",
  URL_SUPPORT: "https://www.4team.biz/livehelp.aspx",
  URL_REFUND_POLICY: "https://www.safepstbackup.com/refundpolicy.aspx",

//structured data
SD_PR_NAME:"Safe PST Backup",
SD_PR_DESCRIPTION:"Purchase, buy #PR_NAME# license and activation code. Order Outlook Tech Support and #PR_NAME# bundle.",
SD_PR_IMAGE:"https://www.safepstbackup.com/i/logo.png",
SD_PR_OPERATING_SYSTEM:"Windows",
SD_PR_VERSION:"3.00.0682",
SD_PR_CATEGORY:"Productivity",
SD_PR_DOWNLOAD_URL:"https://www.safepstbackup.com/download.aspx",
SD_PR_RELEASE_NOTES:"https://www.safepstbackup.com/version-history.aspx",
SD_PR_AUTHOR_NAME:"4Team Corporation",
SD_PR_URL:"https://www.safepstbackup.com/",

SD_OFFERS_PRICE_CURRENCY_USD:"USD",
SD_OFFERS_PRICE_USD:"39.95",
SD_OFFERS_URL_USD:"https://www.safepstbackup.com/purchase/licenses",

SD_OFFERS_PRICE_CURRENCY_GBP:"GBP",
SD_OFFERS_PRICE_GBP:"29.95",
SD_OFFERS_URL_GBP:"https://www.safepstbackup.com/purchase/licenses",

SD_OFFERS_PRICE_CURRENCY_EUR:"EUR",
SD_OFFERS_PRICE_EUR:"39.95",
SD_OFFERS_URL_EUR:"https://www.safepstbackup.com/purchase/licenses",

SD_RATING_WORST:"1",
SD_RATING_BEST:"5",
SD_RATING_VALUE:"4.9",
SD_RATING_COUNT:"1239",

SD_ORGANIZATION_NAME:"4Team Corporation",
SD_ORGANIZATION_IMAGE:"https://www.4team.biz/i/4Team_logo_2.png",
SD_ORGANIZATION_URL:"https://www.4team.biz",
SD_ORGANIZATION_ADDRESS:"5645 Coral Ridge Dr #211",
SD_ORGANIZATION_CITY:"Coral Springs",
SD_ORGANIZATION_REGION:"FL",
SD_ORGANIZATION_ZIP:"33076",
SD_ORGANIZATION_COUNTRY:"USA",
SD_ORGANIZATION_PHONE_USA:" +1 (954) 796-8161",
SD_ORGANIZATION_PHONE_UK:" +44 20 3371 8464",
SD_ORGANIZATION_PHONE_CANADA:"+1 647 477-3340",
SD_ORGANIZATION_PHONE_FRANCE:"+33 1 86 26 42",
//end structured data
}
